import React, { useEffect, useState } from 'react'
import { useRequest } from 'ahooks'
import FButton from '@feedback/components/FButton'
import {
  getFaqDetail,
  setFaqStar,
  setFaqUnStar
} from '@feedback/services/index'
import './App.scss'
import { Toast } from 'antd-mobile'
import { getTextByKey, reportFn } from '@feedback/utils/util'
import qs from 'qs'

interface Props {
  match: any
  history: {
    location: {
      search: string
    }
    push: any
  }
}
const App: React.FC<Props> = ({ history }) => {
  const faq_id: any = qs.parse(history.location.search.split('?')[1]).faq_id
  const { data } = useRequest(() => getFaqDetail({ faq_id }))
  const [isDisabledStar, setDisabledStar] = useState<boolean>(false)
  // 点赞
  const { run: clickStar } = useRequest(setFaqStar, {
    manual: true,
    onSuccess: (result) => {
      const { message, code } = result
      if (code === 0) {
        Toast.success(message, 2)
        setDisabledStar(true)
      } else {
        console.log(message)
      }
    }
  })
  // const { run: clickUnStar } = useRequest(setFaqUnStar, {
  //   manual: true,
  //   onSuccess: (result) => {
  //     const { message, code } = result
  //     if (code === 0) {
  //       console.log('我们会继续加油的')
  //     } else {
  //       console.log(message)
  //     }
  //   }
  // })
  const clickFirFun = () => {
    reportFn({ parm1: 3, parm2: 1, parm6: faq_id })
    clickStar({ faq_id: faq_id })
  }
  const clickSecFun = () => {
    reportFn({ parm1: 3, parm2: 2, parm6: faq_id })
    history.push(`/v1/ticketType`)
  }
  return (
    <div className='p-question-detail'>
      <div className='c-question-panel'>
        {data ? (
          <>
            <p className='question'>{data.data[0].question}</p>
            <div
              className='answer'
              dangerouslySetInnerHTML={{ __html: data.data[0].answer }}
            />
          </>
        ) : null}
      </div>
      <FButton
        firText={getTextByKey('helpful')}
        firDisabled={isDisabledStar}
        firFun={clickFirFun}
        secText={getTextByKey('not helpful')}
        secFun={clickSecFun}
      />
    </div>
  )
}

export default App
